import { Badge, cn } from '@rematter/ui-web';
import { ThemeColor } from '@rematter/ui-web/types';

import { RoleStatus } from './types';

import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export type RoleStatusBadgeProps = {
  status: RoleStatus;
  size?: 'xs' | 'small' | 'default' | 'large';
  className?: string;
};

const statusColors: Record<RoleStatus, ThemeColor> = {
  active: 'success',
  archived: 'failure',
};

export const RoleStatusBadge: React.FC<RoleStatusBadgeProps> = ({
  status,
  size = 'small',
  className,
}) => {
  const t = useTranslations();

  const labelMap: Record<RoleStatus, string> = {
    active: t.teamAndPermissions.roleStatus.active,
    archived: t.teamAndPermissions.roleStatus.archived,
  };

  return (
    <Badge
      color={statusColors[status]}
      size={size}
      className={cn('@RoleStatusBadge', className)}
    >
      {labelMap[status]}
    </Badge>
  );
};
